import { CustomerFeedbackProblemType, FeedbackStatuses } from 'enums/customerFeedback';

export interface FeedbackProps {
  _id: string;
  createdAt: string;
  patientInfo: {
    dob: string;
    doctorId: string;
    name: string;
  };
  problemType?: CustomerFeedbackProblemType;
  providerInfo: {
    name: string;
  };
  rating: number;
  reviewComment: string;
  status: FeedbackStatuses;
}

export interface FeedbackQueryParams {
  createdAt?: string;
  endCreateDate?: string;
  limit?: number;
  localTz?: string;
  pageNo?: number;
  patientName?: string;
  problemType?: string;
  providerName?: string;
  rating?: string;
  searchKey?: string;
  sortField?: string;
  sortOrder?: string;
  startCreateDate?: string;
  status?: string;
}

export interface FeedbackListProps {
  data: FeedbackProps[];
  info: {
    totalCount: number;
  };
}

export const initialState: FeedbackListProps = {
  data: [
    {
      _id: '',
      createdAt: '',
      patientInfo: {
        dob: '',
        doctorId: '',
        name: ''
      },
      providerInfo: {
        name: ''
      },
      rating: 0,
      reviewComment: '',
      status: FeedbackStatuses.New
    }
  ],
  info: {
    totalCount: 0
  }
};
